import { appendCartItems, floatLabels } from './cart-dom-helpers.js';
import { ariaToggle, isTouch, wrapElements } from './dom-utils.js';
import { resizeListener, scrollListener } from './resize-scroll-dispatch.js';
import { initAnimations, loadedImagesEventHook, loading, removeLoadingClassFromLoadedImages } from './scroll-animations.js';

// Safari requestIdleCallback polyfill
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };
window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  };

if (window.theme.settings.enableAnimations) {
  initAnimations();
}

resizeListener();
scrollListener();
isTouch();
loadedImagesEventHook();

window.addEventListener('DOMContentLoaded', () => {
  ariaToggle(document);
  floatLabels(document);
  wrapElements(document);
  removeLoadingClassFromLoadedImages(document);
  loading();
  appendCartItems();

  requestIdleCallback(() => {
    if (Shopify.visualPreviewMode) {
      document.documentElement.classList.add('preview-mode');
    }
  });
});

document.addEventListener('shopify:section:load', (e) => {
  const container = e.target;
  if (typeof container !== 'object' || container.nodeValue === 'undefined') return;

  floatLabels(container);
  wrapElements(container);
  ariaToggle(document);
});
